import { useEffect, useCallback } from "react";

import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import moment from 'moment';

const AuthUrlRedDetail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    const today = new Date();
    const startDate = moment(today).format('YYYY-MM-DD');

    const checkAccess = useCallback(() => {
        const url = new URL(window.location.href);
        const psParam = url.searchParams.get("ps");

        if(psParam){
            dispatch({
                type: 'AUTH',
                newUuid : 'Astronaut789'
            });

            navigate('/detail/'+id);
        }else{
            navigate('/');
        }
    }, [dispatch, navigate, id]);

    useEffect(() => {
        if(process.env.REACT_APP_ENDDATEVERSION <= startDate){
            navigate('/documentation')
        }else{
            checkAccess();
        }
    }, [checkAccess, startDate, navigate]);

    return(
        <p>Check access, please wait...</p>
    )
};

export default AuthUrlRedDetail;